import invariant from 'invariant';
import isObject from 'lodash.isobject';

/**
 * Decorator to ease the conversion of props on the API Response
 * to props in our models (used mainly for sorting on api)
 *
 * @example
 * 	Decorate an model class with this decorator a give it a prop name
 *  Then we can use `ModelClassName.getApiProp(`model_prop_name`)`
 * 	and ModelClassName.getApiValue(`model_prop_name`)
 *
 * @param {String} prop_name API Response map object
 *
 * @returns {Function} Decorator
 */
export default function apiMap(prop_name = 'api_map') {
	return target => {
		invariant(
			isObject(target[prop_name]),
			`${prop_name} must be a static prop and an object mapping api response props to our model props`
		);

		Object.defineProperties(target, {
			getApiProp: {
				configurable: false,
				enumerable: false,
				writable: false,
				value(prop) {
					return target[prop_name][prop];
				},
			},

			getApiValue: {
				configurable: false,
				enumerable: false,
				writable: false,
				value(prop, obj = null) {
					const target = obj || this;
					return target[this.getApiProp(prop)];
				},
			},
		});

		return target;
	};
}



// WEBPACK FOOTER //
// ./src/api/helpers/apiMap.js